export const baseWizardUrl = "/register/wizard";
